/*! INP optimizations: passive events + small interaction scheduler */
(function(){
  try {
    var supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, "passive", { get: function () { supportsPassive = true; } });
      window.addEventListener("test-passive", null, opts);
      window.removeEventListener("test-passive", null, opts);
    } catch (e) {}

    if (supportsPassive) {
      var origAdd = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function(type, listener, options){
        try {
          var passiveEvents = ["touchstart","touchmove","wheel","mousewheel","scroll"];
          if (passiveEvents.indexOf(type) !== -1) {
            if (options === undefined) options = {passive:true};
            else if (typeof options === "boolean") options = {capture: options, passive:true};
            else if (typeof options === "object" && options.passive === undefined) options = Object.assign({}, options, {passive:true});
          }
        } catch(e){}
        return origAdd.call(this, type, listener, options);
      };
    }

    // Lightweight yield helper to avoid long tasks in click handlers
    window.inpYield = function(cb){
      // Break up heavy handlers
      if ("scheduler" in window && scheduler.postTask) {
        return scheduler.postTask(cb, {priority:"user-blocking"});
      }
      return new Promise(function(resolve){
        setTimeout(function(){ try { cb(); } catch(e){} resolve(); }, 0);
      });
    };
  } catch(err) { /* no-op */ }
})();
